import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { isBot } from "@/lib/bots";
import { clampText } from "@/lib/textClamp";

// Texte de publication coupé après `maxChars` avec « Voir plus » / « Voir moins » dépliés SUR PLACE
// (fil, groupes, églises, profils, Découvrir). Les robots reçoivent toujours le texte complet.
// `render(shownText)` = rendu riche (mentions, hashtags, liens) du fragment affiché.
export const ExpandableText = ({ text, maxChars, render = (s) => s, className = "", style, testId = "expandable-text", as: Tag = "p" }) => {
  const { t } = useApp();
  const [expanded, setExpanded] = useState(false);
  const full = String(text || "");
  const { shown, truncated } = isBot() || expanded ? { shown: full, truncated: false } : clampText(full, maxChars);
  const long = truncated || expanded;
  const toggle = (e) => { e.stopPropagation(); setExpanded((v) => !v); };
  const btnStyle = { color: "var(--yalola-text-muted)" };
  return (
    <Tag className={className} style={style} data-testid={testId} data-expanded={long ? (expanded ? "1" : "0") : undefined}>
      {render(shown)}
      {truncated && (
        <>{" "}<button type="button" onClick={toggle} className="text-[14px] font-semibold hover:underline align-baseline" style={btnStyle} data-testid={`${testId}-toggle`}>{t("nav.see_more", "Voir plus")}</button></>
      )}
      {expanded && (
        <>{" "}<button type="button" onClick={toggle} className="text-[14px] font-semibold hover:underline align-baseline" style={btnStyle} data-testid={`${testId}-toggle`}>{t("nav.see_less", "Voir moins")}</button></>
      )}
    </Tag>
  );
};

export default ExpandableText;
